import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useThemeValue } from '../../system';
var sizes = {
  xxs: '8px',
  xs: '10px',
  sm: '12px',
  md: '14px',
  lg: '18px',
  xl: '32px',
  xxl: '48px'
};

function Icon(_ref) {
  var as = _ref.as,
      name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      color = _ref.color,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "name", "size", "color", "children"]);

  var icons = useThemeValue('icons');
  var themeColor = useThemeValue(['colors', color]);
  var iconSize = sizes[size] || size;
  var childrenToRender = name ? jsx("path", {
    d: icons[name]
  }) : children;
  return jsx("svg", _extends({
    viewBox: "0 0 16 16",
    width: iconSize,
    height: iconSize,
    fill: themeColor,
    className: "uikit-reset",
    children: childrenToRender
  }, props));
}

function Path(_ref2) {
  var name = _ref2.name,
      fill = _ref2.fill,
      stroke = _ref2.stroke,
      restProps = _objectWithoutPropertiesLoose(_ref2, ["name", "fill", "stroke"]);

  var themeFill = useThemeValue(['colors', fill]);
  var themeStroke = useThemeValue(['colors', stroke]);
  var icons = useThemeValue('icons');
  return jsx("path", _extends({
    d: icons[name],
    fill: fill ? themeFill || fill : 'none',
    stroke: stroke ? themeStroke || stroke : undefined
  }, restProps));
}

Icon.Path = Path;
export default Icon;